(function () {

  const shuffle = (items) => {

    const list = items.slice();

    for (let i = list.length - 1; i > 0; i -= 1) {

      const j = Math.floor(Math.random() * (i + 1));

      [list[i], list[j]] = [list[j], list[i]];

    }

    return list;

  };



  const getProductPool = (block) => {

    const poolNode = block.querySelector('[data-avignaa-product-pool]');

    if (!poolNode) return [];



    try {

      const pool = JSON.parse(poolNode.textContent || '[]');

      return Array.isArray(pool) ? pool.filter((item) => item && item.title) : [];

    } catch (error) {

      console.error('Avignaa search product pool parse error:', error);

      return [];

    }

  };



  const buildPriceHtml = (product) => {

    const compareAt = parseInt(product.compare_at_price, 10) || 0;

    const price = parseInt(product.price, 10) || 0;

    let html = '<div class="avignaa-search-product-card__price">';



    if (compareAt > price && product.compare_at_price_formatted) {

      html += `<span class="avignaa-search-product-card__price-compare">${product.compare_at_price_formatted}</span>`;

    }



    html += `<span class="avignaa-search-product-card__price-current">${product.price_formatted || ''}</span></div>`;

    return html;

  };



  const buildQuickViewButton = (product, label, extraClass = '') => {

    const handle = product.handle || '';

    const productId = product.id || '';

    const safeLabel = label || 'Quick view';

    const extra = extraClass ? ` ${extraClass}` : '';



    if (!handle) return '';



    return `<button type="button" class="avignaa-search-product-card__atc avignaa-search-product-card__qv${extra}" data-avignaa-search-quickview data-product-handle="${handle}" data-product-id="${productId}">${safeLabel}</button>`;

  };



  const buildProductCard = (product, block) => {

    const title = product.title || '';

    const url = product.url || '#';

    const image = product.image || '';

    const quickViewLabel = block.dataset.quickViewLabel || 'Quick view';



    return `

      <div class="avignaa-search-product-card">

        <a href="${url}" class="avignaa-search-product-card__link">

          <div class="avignaa-search-product-card__media">

            ${image

              ? `<img src="${image}" alt="${title.replace(/"/g, '&quot;')}" class="avignaa-search-product-card__img" loading="lazy" width="500" height="667">`

              : '<div class="avignaa-search-product-card__placeholder"></div>'}

          </div>

          <p class="avignaa-search-product-card__title">${title}</p>

          ${buildPriceHtml(product)}

        </a>

        ${buildQuickViewButton(product, quickViewLabel)}

      </div>

    `;

  };



  const renderLoadingState = (grid, limit) => {

    grid.innerHTML = Array.from({ length: limit }, () => `

      <div class="avignaa-search-product-card avignaa-search-product-card--loading" aria-hidden="true">

        <div class="avignaa-search-product-card__media avignaa-search-product-card__skeleton"></div>

        <div class="avignaa-search-product-card__skeleton avignaa-search-product-card__skeleton--title"></div>

        <div class="avignaa-search-product-card__skeleton avignaa-search-product-card__skeleton--price"></div>

        <div class="avignaa-search-product-card__skeleton avignaa-search-product-card__skeleton--btn"></div>

      </div>

    `).join('');

  };



  const getLabels = (root) => ({

    quickView: root?.closest('[data-avignaa-random-products]')?.dataset.quickViewLabel

      || document.querySelector('[data-avignaa-random-products]')?.dataset.quickViewLabel

      || 'Quick view',

  });



  const getProductHandle = (productEl) => {

    const handleNode = productEl.querySelector('[data-product-handle]');

    if (handleNode?.dataset.productHandle) return handleNode.dataset.productHandle;



    const productItem = productEl.querySelector('.product-item[data-json-product]');

    if (productItem?.dataset.jsonProduct) {

      try {

        const json = JSON.parse(productItem.dataset.jsonProduct);

        if (json.handle) return json.handle;

      } catch (error) {

        console.error('Avignaa search handle parse error:', error);

      }

    }



    const link = productEl.querySelector('.card-title a, .card__heading a, .card-information__text a');

    const href = link?.getAttribute('href') || '';

    const match = href.match(/\/products\/([^/?#]+)/);

    return match ? match[1] : '';

  };



  const hideOriginalSearchButtons = (productEl) => {

    productEl.querySelectorAll('.card-action .button-ATC, .card-information .button-ATC, .card-action button[data-btn-addtocart]').forEach((button) => {

      if (!button.classList.contains('avignaa-search-result-atc')) {

        button.style.display = 'none';

      }

    });

  };



  const getShopRoot = () => window.Shopify?.routes?.root || window.routes?.root || '/';



  const keepSearchOpen = () => {

    document.querySelectorAll('.search_details').forEach((details) => {

      if (details.querySelector('.avignaa-search-modal')) {

        details.setAttribute('open', '');

      }

    });

    document.body.classList.add('avignaa-search-open');

  };



  const closeSearchDrawer = () => {
    const openedFromSearch = document.body.classList.contains('avignaa-search-open')
      || !!document.querySelector('.search_details[open] .avignaa-search-modal');

    document.body.classList.remove('avignaa-search-drawer-open', 'quickshop-popup-show', 'quick-view-show');

    if (openedFromSearch) {
      keepSearchOpen();
    }
  };



  const decorateSearchDrawer = () => {
    const popup = document.getElementById('halo-quickshop-popup-option-3');
    const content = popup?.querySelector('.halo-popup-content');
    const quickshop = content?.querySelector('.quickshop');
    if (!content || !quickshop) return;

    popup.classList.add('avignaa-search-quickshop-drawer');
    quickshop.classList.add('avignaa-drawer-quickshop');

    if (!content.querySelector('.avignaa-drawer-heading')) {
      const heading = document.createElement('div');
      heading.className = 'avignaa-drawer-heading';
      heading.innerHTML = '<h2 class="avignaa-drawer-heading__title">Choose options</h2>';
      content.insertBefore(heading, content.firstChild);
    }

    const hideSource = (selector) => {
      quickshop.querySelectorAll(selector).forEach((node) => {
        node.classList.add('avignaa-drawer-source-hidden');
      });
    };

    hideSource('.halo-productView-left');
    hideSource('.on-desktop-hide');
    hideSource('.productView-title');
    hideSource('.productView-price');
    hideSource('.productView-badge');
    hideSource('form.installment');

    const hideColorOptions = () => {
      quickshop.querySelectorAll('.product-form__input, fieldset.product-form__input').forEach((input) => {
        const labelEl = input.querySelector('legend.form__label, legend, label.form__label, .form__label');
        const name = (labelEl?.textContent || '').trim().toLowerCase();
        const isSwatch = input.classList.contains('product-form__swatch')
          || !!input.querySelector('.pattern, .product-form__label .pattern');
        const isColorName = /\b(color|colour)\b/.test(name);

        if (isSwatch || isColorName) {
          input.classList.add('avignaa-drawer-source-hidden');
        }
      });
    };

    hideColorOptions();

    const imgEl = quickshop.querySelector('.on-desktop-hide img[data-main-image], .on-desktop-hide img, .halo-productView-left img');
    const titleEl = quickshop.querySelector('.productView-title');
    const priceEl = quickshop.querySelector('.productView-price');
    const imgSrc = imgEl?.getAttribute('src') || imgEl?.dataset?.src || '';
    const title = titleEl?.textContent?.trim() || '';
    const priceHtml = priceEl?.innerHTML || '';
    const brandName = window.shop_name || 'AVIGNAA';

    let summary = content.querySelector('.avignaa-drawer-summary');
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'avignaa-drawer-summary';
      const heading = content.querySelector('.avignaa-drawer-heading');
      if (heading) {
        heading.insertAdjacentElement('afterend', summary);
      } else {
        content.insertBefore(summary, content.firstChild);
      }
    }

    summary.innerHTML = `
      <div class="avignaa-drawer-summary__media">
        ${imgSrc ? `<img src="${imgSrc}" alt="${title.replace(/"/g, '&quot;')}" loading="lazy" width="88" height="88">` : ''}
      </div>
      <div class="avignaa-drawer-summary__info">
        <p class="avignaa-drawer-summary__brand">${brandName}</p>
        <p class="avignaa-drawer-summary__title">${title}</p>
        <div class="avignaa-drawer-summary__price">${priceHtml}</div>
      </div>
    `;

    const productViewProduct = quickshop.querySelector('.productView-product');
    if (productViewProduct) {
      productViewProduct.classList.add('avignaa-drawer-product');
    }

    const setupQuantityLayout = () => {
      const cartQty = quickshop.querySelector('cart-update-quantity');
      const qtyInput = quickshop.querySelector('quantity-quick-shop-input.previewCartItem-qty, .previewCartItem-qty');
      if (!cartQty || !qtyInput || cartQty.classList.contains('avignaa-drawer-qty-ready')) return;

      cartQty.classList.add('avignaa-drawer-qty-ready');
      const qtyWrap = document.createElement('div');
      qtyWrap.className = 'avignaa-drawer-qty';
      const qtyLabel = qtyInput.querySelector('.quantity__label');

      if (qtyLabel) {
        qtyLabel.classList.remove('hiddenLabels');
        qtyLabel.textContent = 'Quantity:';
        qtyInput.removeChild(qtyLabel);
        qtyWrap.appendChild(qtyLabel);
      }

      qtyInput.parentNode.insertBefore(qtyWrap, qtyInput);
      qtyWrap.appendChild(qtyInput);
    };

    setupQuantityLayout();

    const seeDetailsBlock = quickshop.querySelector('.productView-see-details');
    const rightCol = quickshop.querySelector('.halo-productView-right');
    if (seeDetailsBlock && rightCol && !seeDetailsBlock.classList.contains('avignaa-drawer-footer')) {
      seeDetailsBlock.classList.add('avignaa-drawer-footer');
      rightCol.appendChild(seeDetailsBlock);
    }

    const seeDetailsLink = quickshop.querySelector('.productView-see-details a, .productView-see-details .button');
    if (seeDetailsLink) {
      seeDetailsLink.textContent = 'View details';
    }

    if (window.Shopify && window.Shopify.PaymentButton) {
      window.Shopify.PaymentButton.init();
    }
  };



  const openSearchQuickDrawer = (handle) => {

    if (!handle) return;



    const quickShopPopup = document.getElementById('halo-quickshop-popup-option-3');

    if (!quickShopPopup) {

      window.location.href = `${getShopRoot()}products/${handle}`;

      return;

    }



    keepSearchOpen();

    document.body.classList.add('avignaa-search-drawer-open');

    document.body.classList.remove('quick-view-show');



    if (typeof jQuery === 'undefined') return;



    const root = getShopRoot();

    const $body = jQuery('body');



    jQuery.ajax({

      type: 'get',

      url: `${root}products/${handle}?view=ajax_quick_shop`,

      beforeSend() {

        jQuery('#halo-quickshop-popup-option-3 .halo-popup-content').html('<div class="avignaa-drawer-loading">Loading...</div>');

      },

      success(data) {

        jQuery('#halo-quickshop-popup-option-3 .halo-popup-content').html(data);

        decorateSearchDrawer();

      },

      complete() {
        window.setTimeout(() => {
          keepSearchOpen();
          $body.addClass('quickshop-popup-show avignaa-search-drawer-open');
          $body.removeClass('quick-view-show');

          if (window.Shopify && window.Shopify.PaymentButton) {
            window.Shopify.PaymentButton.init();
          }

          if (window.show_multiple_currencies && typeof Currency !== 'undefined') {

            const activeCurrency = jQuery('#currencies .active').attr('data-currency');

            if (activeCurrency) {

              Currency.convertAll(window.shop_currency, activeCurrency, 'span.money', 'money_format');

            }

          }

        }, 120);

      },

      error(xhr) {

        console.error('Avignaa search quick drawer failed:', xhr);

        closeSearchDrawer();

      },

    });

  };



  const enhancePredictiveSearchResults = (root) => {

    if (!root) return;



    const labels = getLabels(root);



    root.querySelectorAll('.products-grid .product').forEach((productEl) => {

      hideOriginalSearchButtons(productEl);



      if (productEl.querySelector('.avignaa-search-result-atc')) return;



      const handle = getProductHandle(productEl);

      const productId = productEl.querySelector('.product-item')?.dataset.productId

        || productEl.querySelector('form.variants')?.dataset.productId

        || '';

      const cardInfo = productEl.querySelector('.card-information');

      const buttonHtml = buildQuickViewButton({ handle, id: productId }, labels.quickView, 'avignaa-search-result-atc');



      if (cardInfo && buttonHtml) {

        cardInfo.insertAdjacentHTML('beforeend', buttonHtml);

      }

    });

  };



  window.avignaaEnhanceSearchResults = enhancePredictiveSearchResults;



  const loadRandomProducts = (block) => {

    const grid = block.querySelector('[data-avignaa-random-grid]');

    if (!grid) return;



    const limit = parseInt(block.dataset.productLimit, 10) || 8;

    renderLoadingState(grid, limit);



    window.requestAnimationFrame(() => {

      const pool = getProductPool(block);

      const products = shuffle(pool).slice(0, limit);



      if (!products.length) {

        grid.innerHTML = '<p class="avignaa-search-products__empty">No products available right now.</p>';

        return;

      }



      grid.innerHTML = products.map((product) => buildProductCard(product, block)).join('');



      if (window.show_multiple_currencies && typeof Currency !== 'undefined' && typeof jQuery !== 'undefined') {

        const activeCurrency = jQuery('#currencies .active').attr('data-currency');

        if (activeCurrency) {

          Currency.convertAll(window.shop_currency, activeCurrency, 'span.money', 'money_format');

        }

      }

    });

  };



  const bindSearchBlock = (block) => {

    if (block.dataset.avignaaRandomBound === 'true') return;

    block.dataset.avignaaRandomBound = 'true';



    const searchDetails = block.closest('.search_details');

    const mobileSearchRoot = block.closest('#search-form-mobile');

    let loadTimer = null;



    const handleOpen = () => {

      window.clearTimeout(loadTimer);

      loadTimer = window.setTimeout(() => loadRandomProducts(block), 30);

    };



    if (searchDetails) {

      const onDetailsOpen = () => {

        if (!searchDetails.hasAttribute('open')) return;

        handleOpen();

      };



      new MutationObserver(onDetailsOpen).observe(searchDetails, {

        attributes: true,

        attributeFilter: ['open'],

      });



      searchDetails.addEventListener('toggle', onDetailsOpen);

      if (searchDetails.hasAttribute('open')) onDetailsOpen();

    }



    if (mobileSearchRoot) {

      const onMobileOpen = () => {

        if (!document.body.classList.contains('open_search_mobile')) return;

        handleOpen();

      };



      new MutationObserver(onMobileOpen).observe(document.body, {

        attributes: true,

        attributeFilter: ['class'],

      });



      document.querySelectorAll('[data-search-mobile]').forEach((trigger) => {

        trigger.addEventListener('click', () => {

          window.setTimeout(handleOpen, 120);

        });

      });



      if (document.body.classList.contains('open_search_mobile')) onMobileOpen();

    }

  };



  const initSearchBlocks = () => {

    document.querySelectorAll('[data-avignaa-random-products]').forEach(bindSearchBlock);

  };



  document.addEventListener('click', (event) => {

    const quickViewButton = event.target.closest('[data-avignaa-search-quickview]');

    if (quickViewButton) {

      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();



      const handle = quickViewButton.dataset.productHandle;

      if (handle) openSearchQuickDrawer(handle);

      return;

    }



    if (event.target.closest('[data-close-quick-shop-popup]') && document.body.classList.contains('avignaa-search-drawer-open')) {

      closeSearchDrawer();

      return;

    }



    if (

      document.body.classList.contains('avignaa-search-drawer-open')

      && event.target.classList.contains('background-overlay')

    ) {

      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();

      closeSearchDrawer();

    }

  }, true);



  document.addEventListener('click', (event) => {

    if (!document.body.classList.contains('avignaa-search-drawer-open')) return;



    const isInsideDrawer = event.target.closest('#halo-quickshop-popup-option-3');

    const isQuickViewButton = event.target.closest('[data-avignaa-search-quickview]');

    const isSearchUi = event.target.closest('.avignaa-search-modal, .search_details[open]');



    if (!isInsideDrawer && !isQuickViewButton && !isSearchUi && !event.target.closest('.background-overlay')) {

      event.stopPropagation();

    }

  }, true);



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', initSearchBlocks);

  } else {

    initSearchBlocks();

  }



  document.addEventListener('shopify:section:load', initSearchBlocks);

})();


